import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';
import { css, cx } from 'linaria';
import React, { useContext, useEffect } from 'react';
import { ActiveCarot } from './ActiveCarot';
import { filterName } from './shared/styles';
import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import { FakedRangeFilter } from '../FakedRangeFilters';
import { AccordionContent } from '../../../ProductPage/AccordionContent';
import { StoreContext } from '../../../StoreHandler/StoreContext';

export const filtersStyle = css`
  list-style: none;
  padding-left: 0;

  li button {
    padding: 6px 0;
    width: 100%;
    display: flex;
    background: transparent;
    border-top: 1px solid white;
    background: white;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    span {
      /* result count */
      color: #878787;
      margin-left: 10px;
      font-size: 14px;
    }
    .check {
      path {
        fill: #911827;
      }
    }
    &.active {
      justify-content: space-between;
    }
  }
`;

export const ListAccordion = ({ filters, accordionProps, startingIdx = 0 }) => {
  if (!filters) return null;

  const listFilters = filters.filter(
    (filter) => filter.__typename === 'ListFilter'
  );

  return (
    <>
      {listFilters.map((filter, idx) => (
        <div
          key={filter.id}
          style={{ display: filter.name === 'Butik' ? 'none' : '' }}
        >
          <ListFilter
            key={filter.id}
            filter={filter}
            idx={idx}
            startingIdx={startingIdx}
            accordionProps={accordionProps}
          />
        </div>
      ))}
    </>
  );
};

function ListFilter({ filter, idx, accordionProps, startingIdx }) {
  const { apply } = useListFilter({ filter });
  const { selectedStore } = useContext(StoreContext);
  const accordionIsOpen = accordionProps.openIndexes.includes(
    idx + startingIdx
  );

  useEffect(() => {
    if (typeof window === 'undefined' || filter.name.toLowerCase() !== 'butik')
      return;

    let mounted = true;
    const currentPage = new URLSearchParams(window.location.search).get('page');

    // Clear existing selections if we have any
    filter.items.forEach((item) => {
      if (item.isActive) {
        apply({ value: item.value });
      }
    });

    const netStoreFilterItem = filter.items.find(
      (item) => item.text.toLowerCase() === 'nätbutik'
    );
    if (netStoreFilterItem) {
      apply({ value: netStoreFilterItem.value }).then(() => {
        if (!mounted) return;
        if (currentPage) {
          const newUrl = new URL(window.location.href);
          const params = new URLSearchParams(newUrl.search);
          params.set('page', currentPage);
          newUrl.search = decodeURIComponent(params.toString());
          window.history.replaceState({}, '', newUrl);
        }
      });
    }

    if (selectedStore) {
      const storeFilterItem = filter.items.find(
        (item) => item.text === selectedStore.name
      );
      if (storeFilterItem) {
        apply({ value: storeFilterItem.value }).then(() => {
          if (!mounted) return;
          if (currentPage) {
            const newUrl = new URL(window.location.href);
            const params = new URLSearchParams(newUrl.search);
            params.set('page', currentPage);
            newUrl.search = decodeURIComponent(params.toString());
            window.history.replaceState({}, '', newUrl);
          }
        });
      }
    }

    return () => {
      mounted = false;
    };
  }, [selectedStore, filter]);

  const useFakeRangeFilter = [
    'bredd',
    'längd',
    'diameter',
    'höjd',
    'djup',
    'sitthöjd',
    'sittdjup',
    'vikt',
  ];

  return (
    <>
      <div
        className={filterName}
        onClick={() => accordionProps.handleClick(idx)}
        style={{ textTransform: 'capitalize' }}
      >
        {filter.name.toLowerCase()}
        <ActiveCarot
          isActive={filter.hasActiveItems}
          isOpen={accordionIsOpen}
        />
      </div>
      <AccordionContent isOpen={accordionIsOpen}>
        {useFakeRangeFilter.includes(filter.name.toLowerCase()) ? (
          <FakedRangeFilter filter={filter} mobile />
        ) : (
          <ul className={filtersStyle}>
            {filter.items.map((item) => (
              <li key={item.id}>
                <button
                  className={cx(item.isActive && 'active')}
                  onClick={() => apply({ value: item.value })}
                >
                  {item.text}

                  {item.isActive ? (
                    <Check className={'check'} />
                  ) : (
                    <span>({item.resultCount})</span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        )}
      </AccordionContent>
    </>
  );
}
